(() => {
  const CUSTOM_KITTING_VARIANT_ID = 53061189763345; // <-- replace with your Custom Kitting VARIANT ID

  if (window.__ck_loaded_debug_v1) return;
  window.__ck_loaded_debug_v1 = true;

  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"], form[action*="/cart/add"]';
  const CHECKBOX_SELECTOR = '.js-custom-kitting-checkbox';
  const FLAG_SELECTOR = '.js-custom-kitting-flag';

  // Match Dawn-ish ATC buttons + common variants
  const ATC_BUTTON_SELECTOR = [
    'button[type="submit"]',
    'input[type="submit"]',
    'button[name="add"]',
    '.add-to-cart-button',
    '[data-testid="add-to-cart"]',
    '[data-action="add-to-cart"]'
  ].join(',');

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

  async function addItems(items) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    // If Shopify returns an error, it will still be JSON sometimes
    const text = await res.text();
    if (!res.ok) throw new Error(text || 'Cart add failed');

    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }

  function wantsKitting(form) {
    const cb = form.querySelector(CHECKBOX_SELECTOR);
    if (cb && cb.checked) return true;

    const flag = form.querySelector(FLAG_SELECTOR);
    return flag && String(flag.value) === '1';
  }

  let busy = false;

  async function runAdd(form) {
    const fd = new FormData(form);

    const canvasVariantId = Number(fd.get('id'));
    if (!canvasVariantId) throw new Error('No canvas variant ID found in form.');

    const qtyRaw = fd.get('quantity');
    const quantity = qtyRaw ? Math.max(1, parseInt(String(qtyRaw), 10)) : 1;

    const sellingPlan = fd.get('selling_plan');

    console.log('[Custom Kitting] Attempting add', {
      canvasVariantId,
      quantity,
      CUSTOM_KITTING_VARIANT_ID
    });

    const canvasItem = {
      id: canvasVariantId,
      quantity,
      properties: {
        'Custom kitting': 'Yes — contact customer for fibers/budget; threads invoiced separately'
      }
    };
    if (sellingPlan) canvasItem.selling_plan = sellingPlan;

    const kittingItem = {
      id: Number(CUSTOM_KITTING_VARIANT_ID),
      quantity,
      properties: { 'Associated canvas variant': String(canvasVariantId) }
    };

    return addItems([canvasItem, kittingItem]);
  }

  async function handle(form, event, source) {
    if (!form || !form.matches(FORM_SELECTOR)) return false;
    if (!wantsKitting(form)) return false;

    // We only block the theme if the box is checked
    event.preventDefault();
    event.stopImmediatePropagation();

    if (busy) {
      console.log('[Custom Kitting] Busy - ignoring duplicate trigger:', source);
      return true;
    }
    busy = true;

    try {
      if (!Number.isFinite(Number(CUSTOM_KITTING_VARIANT_ID))) {
        throw new Error('CUSTOM_KITTING_VARIANT_ID is not a valid number.');
      }

      console.log('[Custom Kitting] Intercepted ATC via:', source);

      const result = await runAdd(form);
      console.log('[Custom Kitting] Add result:', result);

      // Refresh cart UI + open drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';

      return true;
    } catch (err) {
      console.error('[Custom Kitting] ERROR:', err);

      // Fail open: uncheck and let normal add-to-cart happen
      const cb = form.querySelector(CHECKBOX_SELECTOR);
      const flag = form.querySelector(FLAG_SELECTOR);
      if (cb) cb.checked = false;
      if (flag) flag.value = '0';

      // Let the theme proceed normally now
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();

      return true;
    } finally {
      busy = false;
    }
  }

  // Capture submit (covers normal forms)
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      handle(form, e, 'submit');
    },
    true
  );

  // Capture click on many possible ATC buttons (covers Dawn/custom components)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(ATC_BUTTON_SELECTOR);
      if (!btn) return;

      const form = btn.closest('form');
      if (!form) return;

      // Helpful: prove we saw the click even if box is unchecked
      const cb = form.querySelector(CHECKBOX_SELECTOR);
      console.log('[Custom Kitting] ATC click seen. checkbox checked?', !!cb && cb.checked);

      handle(form, e, 'click');
    },
    true
  );

  console.log('[Custom Kitting] Loaded ✅');
})();
